// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DocumentUpload,
    ObjectNoResponse,
    ProviderCreateDocumentPayload,
    ProviderDocument,
    ProviderDocumentSortType,
    ProviderDocumentTranscription,
    ProviderDocumentUrl,
    SupportCreateDocumentAppealPayload,
    SupportCreateDocumentClaimTransmissionPayload,
    SupportCreateDocumentCombinePayload,
    SupportCreateDocumentCopyPayload,
    SupportCreateDocumentDentalPayload,
    SupportCreateDocumentEFTPayload,
    SupportCreateDocumentERAPayload,
    SupportCreateDocumentInstitutionalPayload,
    SupportCreateDocumentNynf3Payload,
    SupportCreateDocumentPayload,
    SupportCreateDocumentPaymentPayload,
    SupportCreateDocumentProfessionalPayload,
    SupportCreateDocumentProofOfTransmissionPayload,
    SupportCreateDocumentResizePayload,
    SupportCreateDocumentZipPayload,
    SupportDocument,
    SupportDocumentOcr,
    SupportDocumentOcrAnalyze,
    SupportDocumentSortType,
    SupportDocumentTranscription,
    SupportDocumentUrl,
    SupportUpdateDocumentPayload,
    TemporaryDocumentUrl,
    ProviderCreateDocumentPayloadToJSON,
    SupportCreateDocumentAppealPayloadToJSON,
    SupportCreateDocumentClaimTransmissionPayloadToJSON,
    SupportCreateDocumentCombinePayloadToJSON,
    SupportCreateDocumentCopyPayloadToJSON,
    SupportCreateDocumentDentalPayloadToJSON,
    SupportCreateDocumentEFTPayloadToJSON,
    SupportCreateDocumentERAPayloadToJSON,
    SupportCreateDocumentInstitutionalPayloadToJSON,
    SupportCreateDocumentNynf3PayloadToJSON,
    SupportCreateDocumentPayloadToJSON,
    SupportCreateDocumentPaymentPayloadToJSON,
    SupportCreateDocumentProfessionalPayloadToJSON,
    SupportCreateDocumentProofOfTransmissionPayloadToJSON,
    SupportCreateDocumentResizePayloadToJSON,
    SupportCreateDocumentZipPayloadToJSON,
    SupportUpdateDocumentPayloadToJSON,
    DocumentUploadFromJSON,
    ObjectNoResponseFromJSON,
    ProviderDocumentFromJSON,
    ProviderDocumentTranscriptionFromJSON,
    ProviderDocumentUrlFromJSON,
    SupportDocumentFromJSON,
    SupportDocumentOcrFromJSON,
    SupportDocumentOcrAnalyzeFromJSON,
    SupportDocumentTranscriptionFromJSON,
    SupportDocumentUrlFromJSON,
    TemporaryDocumentUrlFromJSON,
} from '../models';

export interface CombineDocumentsRequest {
    supportCreateDocumentCombinePayload: SupportCreateDocumentCombinePayload;
}

export interface CopyDocumentRequest {
    id: string;
    supportCreateDocumentCopyPayload: SupportCreateDocumentCopyPayload;
}

export interface CreateProviderDocumentRequest {
    providerCreateDocumentPayload: ProviderCreateDocumentPayload;
}

export interface CreateProviderDocumentUploadRequest {
    id: string;
    body: object;
}

export interface CreateSupportCMS1450DocumentRequest {
    id: string;
    supportCreateDocumentInstitutionalPayload: SupportCreateDocumentInstitutionalPayload;
}

export interface CreateSupportCMS1500DocumentRequest {
    id: string;
    supportCreateDocumentProfessionalPayload: SupportCreateDocumentProfessionalPayload;
}

export interface CreateSupportClaimTransmissionDocumentRequest {
    id: string;
    supportCreateDocumentClaimTransmissionPayload: SupportCreateDocumentClaimTransmissionPayload;
}

export interface CreateSupportClearinghouseEraExplanationOfBenefitsDocumentRequest {
    id: string;
    supportCreateDocumentPaymentPayload: SupportCreateDocumentPaymentPayload;
}

export interface CreateSupportClearinghouseEraItemExplanationOfBenefitsDocumentRequest {
    id: string;
    supportCreateDocumentPaymentPayload: SupportCreateDocumentPaymentPayload;
}

export interface CreateSupportDentalDocumentRequest {
    id: string;
    supportCreateDocumentDentalPayload: SupportCreateDocumentDentalPayload;
}

export interface CreateSupportDeprecatedProofOfTransmissionDocumentRequest {
    id: string;
    supportCreateDocumentProofOfTransmissionPayload: SupportCreateDocumentProofOfTransmissionPayload;
}

export interface CreateSupportDocumentRequest {
    supportCreateDocumentPayload: SupportCreateDocumentPayload;
}

export interface CreateSupportDocumentGuarantorQuestionnaireRequest {
    id: string;
    supportCreateDocumentAppealPayload: SupportCreateDocumentAppealPayload;
}

export interface CreateSupportDocumentPayerAppealRequestRequest {
    id: string;
    supportCreateDocumentAppealPayload: SupportCreateDocumentAppealPayload;
}

export interface CreateSupportDocumentPayerEFTRequestRequest {
    id: string;
    supportCreateDocumentEFTPayload: SupportCreateDocumentEFTPayload;
}

export interface CreateSupportDocumentPayerERARequestRequest {
    id: string;
    supportCreateDocumentERAPayload: SupportCreateDocumentERAPayload;
}

export interface CreateSupportDocumentUploadRequest {
    id: string;
    body: object;
}

export interface CreateSupportEOBExplanationOfBenefitsDocumentRequest {
    id: string;
    supportCreateDocumentPaymentPayload: SupportCreateDocumentPaymentPayload;
}

export interface CreateSupportEOBPaymentExplanationOfBenefitsDocumentRequest {
    id: string;
    supportCreateDocumentPaymentPayload: SupportCreateDocumentPaymentPayload;
}

export interface CreateSupportNynf3DocumentRequest {
    id: string;
    supportCreateDocumentNynf3Payload: SupportCreateDocumentNynf3Payload;
}

export interface CreateSupportPaymentExplanationOfBenefitsDocumentRequest {
    id: string;
    supportCreateDocumentPaymentPayload: SupportCreateDocumentPaymentPayload;
}

export interface CreateSupportProofOfTransmissionDocumentRequest {
    id: string;
    supportCreateDocumentProofOfTransmissionPayload: SupportCreateDocumentProofOfTransmissionPayload;
}

export interface DisableSupportDocumentRequest {
    id: string;
}

export interface EnableSupportDocumentRequest {
    id: string;
}

export interface GenerateDocumentOcrRequest {
    id: string;
}

export interface GenerateDocumentOcrAnalyzeRequest {
    id: string;
    body: object;
}

export interface GetProviderDocumentRequest {
    id: string;
}

export interface GetProviderDocumentTranscriptionRequest {
    id: string;
}

export interface GetProviderDocumentUrlRequest {
    id: string;
}

export interface GetProviderEmbedDocumentUrlRequest {
    id: string;
}

export interface GetSupportDocumentRequest {
    id: string;
}

export interface GetSupportDocumentOcrRequest {
    id: string;
}

export interface GetSupportDocumentOcrAnalyzeRequest {
    id: string;
}

export interface GetSupportDocumentTranscriptionRequest {
    id: string;
}

export interface GetSupportDocumentUrlRequest {
    id: string;
}

export interface GetSupportEmbedDocumentPageImageUrlRequest {
    id: string;
    pageNumber?: number;
}

export interface GetSupportEmbedDocumentUrlRequest {
    id: string;
}

export interface ListProviderDocumentsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderDocumentsOrderEnum>;
    filterCreated?: Array<string>;
    filterFilename?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentType?: Array<string>;
    sort?: Array<ProviderDocumentSortType>;
}

export interface ListSupportDocumentsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportDocumentsOrderEnum>;
    filterCreated?: Array<string>;
    filterTag?: Array<string>;
    filterActive?: string;
    filterFilename?: Array<string>;
    filterClaimId?: Array<string>;
    filterDocumentType?: Array<string>;
    sort?: Array<SupportDocumentSortType>;
}

export interface RefreshDocumentMetadataRequest {
    id: string;
    body: object;
}

export interface RefreshProviderDocumentMetadataRequest {
    id: string;
    body: object;
}

export interface ResizeDocumentRequest {
    id: string;
    supportCreateDocumentResizePayload: SupportCreateDocumentResizePayload;
}

export interface UpdateSupportDocumentRequest {
    id: string;
    supportUpdateDocumentPayload: SupportUpdateDocumentPayload;
}

export interface ViewProviderCMS1450DocumentRequest {
    id: string;
    editable?: boolean;
}

export interface ViewProviderCMS1500DocumentRequest {
    id: string;
    payerSubscriberId: string;
    subscriberPatientId: string;
    editable?: boolean;
}

export interface ViewProviderClaimTransmissionDocumentRequest {
    id: string;
}

export interface ViewProviderPaymentExplanationOfBenefitsDocumentRequest {
    id: string;
}

export interface ViewSupportCMS1450DocumentRequest {
    id: string;
    editable?: boolean;
}

export interface ViewSupportCMS1500DocumentRequest {
    id: string;
    payerSubscriberId: string;
    subscriberPatientId: string;
    editable?: boolean;
}

export interface ViewSupportClaimTransmissionDocumentRequest {
    id: string;
}

export interface ViewSupportClearinghouseEraExplanationOfBenefitsDocumentRequest {
    id: string;
}

export interface ViewSupportClearinghouseEraItemExplanationOfBenefitsDocumentRequest {
    id: string;
}

export interface ViewSupportEOBExplanationOfBenefitsDocumentRequest {
    id: string;
}

export interface ViewSupportEOBPaymentExplanationOfBenefitsDocumentRequest {
    id: string;
}

export interface ViewSupportNynf3DocumentRequest {
    id: string;
    payerSubscriberId: string;
    subscriberPatientId: string;
    editable?: boolean;
}

export interface ViewSupportPaymentExplanationOfBenefitsDocumentRequest {
    id: string;
}

export interface ViewSupportProofOfTransmissionDocumentRequest {
    id: string;
}

export interface ZipDocumentsRequest {
    supportCreateDocumentZipPayload: SupportCreateDocumentZipPayload;
}

/**
 * no description
 */
export class DocumentApi extends runtime.BaseAPI {

    /**
     * Combine documents
     * Combine documents into a new document
     */
    async combineDocumentsRaw(requestParameters: CombineDocumentsRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['supportCreateDocumentCombinePayload'] === null || requestParameters['supportCreateDocumentCombinePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentCombinePayload','Required parameter requestParameters.supportCreateDocumentCombinePayload was null or undefined when calling combineDocuments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/combine`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentCombinePayloadToJSON(requestParameters['supportCreateDocumentCombinePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Combine documents
     * Combine documents into a new document
     */
    async combineDocuments(requestParameters: CombineDocumentsRequest): Promise<SupportDocument> {
        const response = await this.combineDocumentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Copy a document
     * Copy a document
     */
    async copyDocumentRaw(requestParameters: CopyDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling copyDocument.');
        }

        if (requestParameters['supportCreateDocumentCopyPayload'] === null || requestParameters['supportCreateDocumentCopyPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentCopyPayload','Required parameter requestParameters.supportCreateDocumentCopyPayload was null or undefined when calling copyDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/copy`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentCopyPayloadToJSON(requestParameters['supportCreateDocumentCopyPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Copy a document
     * Copy a document
     */
    async copyDocument(requestParameters: CopyDocumentRequest): Promise<SupportDocument> {
        const response = await this.copyDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a document shell. See recipe for details.
     * Create a document
     */
    async createProviderDocumentRaw(requestParameters: CreateProviderDocumentRequest): Promise<runtime.ApiResponse<ProviderDocument>> {
        if (requestParameters['providerCreateDocumentPayload'] === null || requestParameters['providerCreateDocumentPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateDocumentPayload','Required parameter requestParameters.providerCreateDocumentPayload was null or undefined when calling createProviderDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateDocumentPayloadToJSON(requestParameters['providerCreateDocumentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderDocumentFromJSON(jsonValue));
    }

    /**
     * Create a document shell. See recipe for details.
     * Create a document
     */
    async createProviderDocument(requestParameters: CreateProviderDocumentRequest): Promise<ProviderDocument> {
        const response = await this.createProviderDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a secure presigned url to upload the document contents
     * Create a document upload link
     */
    async createProviderDocumentUploadRaw(requestParameters: CreateProviderDocumentUploadRequest): Promise<runtime.ApiResponse<DocumentUpload>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createProviderDocumentUpload.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling createProviderDocumentUpload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "update:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/{id}/upload`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentUploadFromJSON(jsonValue));
    }

    /**
     * Create a secure presigned url to upload the document contents
     * Create a document upload link
     */
    async createProviderDocumentUpload(requestParameters: CreateProviderDocumentUploadRequest): Promise<DocumentUpload> {
        const response = await this.createProviderDocumentUploadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a CM1450 paper claim
     * Create a paper CMS1450 from an institutional claim
     */
    async createSupportCMS1450DocumentRaw(requestParameters: CreateSupportCMS1450DocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportCMS1450Document.');
        }

        if (requestParameters['supportCreateDocumentInstitutionalPayload'] === null || requestParameters['supportCreateDocumentInstitutionalPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentInstitutionalPayload','Required parameter requestParameters.supportCreateDocumentInstitutionalPayload was null or undefined when calling createSupportCMS1450Document.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/institutional/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentInstitutionalPayloadToJSON(requestParameters['supportCreateDocumentInstitutionalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Create a CM1450 paper claim
     * Create a paper CMS1450 from an institutional claim
     */
    async createSupportCMS1450Document(requestParameters: CreateSupportCMS1450DocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportCMS1450DocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a CMS1500 document
     * Create a paper CMS1500 from a professional claim
     */
    async createSupportCMS1500DocumentRaw(requestParameters: CreateSupportCMS1500DocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportCMS1500Document.');
        }

        if (requestParameters['supportCreateDocumentProfessionalPayload'] === null || requestParameters['supportCreateDocumentProfessionalPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentProfessionalPayload','Required parameter requestParameters.supportCreateDocumentProfessionalPayload was null or undefined when calling createSupportCMS1500Document.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/professional/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentProfessionalPayloadToJSON(requestParameters['supportCreateDocumentProfessionalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Create a CMS1500 document
     * Create a paper CMS1500 from a professional claim
     */
    async createSupportCMS1500Document(requestParameters: CreateSupportCMS1500DocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportCMS1500DocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a paper claim of an electronic transmission
     * Creates a paper claim of an electronic transmission
     */
    async createSupportClaimTransmissionDocumentRaw(requestParameters: CreateSupportClaimTransmissionDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportClaimTransmissionDocument.');
        }

        if (requestParameters['supportCreateDocumentClaimTransmissionPayload'] === null || requestParameters['supportCreateDocumentClaimTransmissionPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentClaimTransmissionPayload','Required parameter requestParameters.supportCreateDocumentClaimTransmissionPayload was null or undefined when calling createSupportClaimTransmissionDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/transmission/{id}/claim`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentClaimTransmissionPayloadToJSON(requestParameters['supportCreateDocumentClaimTransmissionPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Creates a paper claim of an electronic transmission
     * Creates a paper claim of an electronic transmission
     */
    async createSupportClaimTransmissionDocument(requestParameters: CreateSupportClaimTransmissionDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportClaimTransmissionDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportClearinghouseEraExplanationOfBenefitsDocumentRaw(requestParameters: CreateSupportClearinghouseEraExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportClearinghouseEraExplanationOfBenefitsDocument.');
        }

        if (requestParameters['supportCreateDocumentPaymentPayload'] === null || requestParameters['supportCreateDocumentPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentPaymentPayload','Required parameter requestParameters.supportCreateDocumentPaymentPayload was null or undefined when calling createSupportClearinghouseEraExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/clearinghouse/era/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentPaymentPayloadToJSON(requestParameters['supportCreateDocumentPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportClearinghouseEraExplanationOfBenefitsDocument(requestParameters: CreateSupportClearinghouseEraExplanationOfBenefitsDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportClearinghouseEraExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportClearinghouseEraItemExplanationOfBenefitsDocumentRaw(requestParameters: CreateSupportClearinghouseEraItemExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportClearinghouseEraItemExplanationOfBenefitsDocument.');
        }

        if (requestParameters['supportCreateDocumentPaymentPayload'] === null || requestParameters['supportCreateDocumentPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentPaymentPayload','Required parameter requestParameters.supportCreateDocumentPaymentPayload was null or undefined when calling createSupportClearinghouseEraItemExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/clearinghouse/era/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentPaymentPayloadToJSON(requestParameters['supportCreateDocumentPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportClearinghouseEraItemExplanationOfBenefitsDocument(requestParameters: CreateSupportClearinghouseEraItemExplanationOfBenefitsDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportClearinghouseEraItemExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a paper dental claim
     * Create a paper dental form from an NF3 claim
     */
    async createSupportDentalDocumentRaw(requestParameters: CreateSupportDentalDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportDentalDocument.');
        }

        if (requestParameters['supportCreateDocumentDentalPayload'] === null || requestParameters['supportCreateDocumentDentalPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentDentalPayload','Required parameter requestParameters.supportCreateDocumentDentalPayload was null or undefined when calling createSupportDentalDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/dental/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentDentalPayloadToJSON(requestParameters['supportCreateDocumentDentalPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Create a paper dental claim
     * Create a paper dental form from an NF3 claim
     */
    async createSupportDentalDocument(requestParameters: CreateSupportDentalDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportDentalDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a paper proof of electronic transmission
     * Creates a paper proof of electronic transmission
     */
    async createSupportDeprecatedProofOfTransmissionDocumentRaw(requestParameters: CreateSupportDeprecatedProofOfTransmissionDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportDeprecatedProofOfTransmissionDocument.');
        }

        if (requestParameters['supportCreateDocumentProofOfTransmissionPayload'] === null || requestParameters['supportCreateDocumentProofOfTransmissionPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentProofOfTransmissionPayload','Required parameter requestParameters.supportCreateDocumentProofOfTransmissionPayload was null or undefined when calling createSupportDeprecatedProofOfTransmissionDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/transmission/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentProofOfTransmissionPayloadToJSON(requestParameters['supportCreateDocumentProofOfTransmissionPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Creates a paper proof of electronic transmission
     * Creates a paper proof of electronic transmission
     */
    async createSupportDeprecatedProofOfTransmissionDocument(requestParameters: CreateSupportDeprecatedProofOfTransmissionDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportDeprecatedProofOfTransmissionDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a binary document.
     * Create a document
     */
    async createSupportDocumentRaw(requestParameters: CreateSupportDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['supportCreateDocumentPayload'] === null || requestParameters['supportCreateDocumentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentPayload','Required parameter requestParameters.supportCreateDocumentPayload was null or undefined when calling createSupportDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentPayloadToJSON(requestParameters['supportCreateDocumentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Create a binary document.
     * Create a document
     */
    async createSupportDocument(requestParameters: CreateSupportDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a document guarantor questionnaire reminder
     * Create a document guarantor questionnaire reminder
     */
    async createSupportDocumentGuarantorQuestionnaireRaw(requestParameters: CreateSupportDocumentGuarantorQuestionnaireRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportDocumentGuarantorQuestionnaire.');
        }

        if (requestParameters['supportCreateDocumentAppealPayload'] === null || requestParameters['supportCreateDocumentAppealPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentAppealPayload','Required parameter requestParameters.supportCreateDocumentAppealPayload was null or undefined when calling createSupportDocumentGuarantorQuestionnaire.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/payment/{id}/guarantor_questionnaire`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentAppealPayloadToJSON(requestParameters['supportCreateDocumentAppealPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Create a document guarantor questionnaire reminder
     * Create a document guarantor questionnaire reminder
     */
    async createSupportDocumentGuarantorQuestionnaire(requestParameters: CreateSupportDocumentGuarantorQuestionnaireRequest): Promise<SupportDocument> {
        const response = await this.createSupportDocumentGuarantorQuestionnaireRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a document payer appeal request
     * Create a document payer appeal request
     */
    async createSupportDocumentPayerAppealRequestRaw(requestParameters: CreateSupportDocumentPayerAppealRequestRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportDocumentPayerAppealRequest.');
        }

        if (requestParameters['supportCreateDocumentAppealPayload'] === null || requestParameters['supportCreateDocumentAppealPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentAppealPayload','Required parameter requestParameters.supportCreateDocumentAppealPayload was null or undefined when calling createSupportDocumentPayerAppealRequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/payer/{id}/appeal`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentAppealPayloadToJSON(requestParameters['supportCreateDocumentAppealPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Create a document payer appeal request
     * Create a document payer appeal request
     */
    async createSupportDocumentPayerAppealRequest(requestParameters: CreateSupportDocumentPayerAppealRequestRequest): Promise<SupportDocument> {
        const response = await this.createSupportDocumentPayerAppealRequestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a document payer EFT request
     * Create an EFT
     */
    async createSupportDocumentPayerEFTRequestRaw(requestParameters: CreateSupportDocumentPayerEFTRequestRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportDocumentPayerEFTRequest.');
        }

        if (requestParameters['supportCreateDocumentEFTPayload'] === null || requestParameters['supportCreateDocumentEFTPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentEFTPayload','Required parameter requestParameters.supportCreateDocumentEFTPayload was null or undefined when calling createSupportDocumentPayerEFTRequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/payer/{id}/eft`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentEFTPayloadToJSON(requestParameters['supportCreateDocumentEFTPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Create a document payer EFT request
     * Create an EFT
     */
    async createSupportDocumentPayerEFTRequest(requestParameters: CreateSupportDocumentPayerEFTRequestRequest): Promise<SupportDocument> {
        const response = await this.createSupportDocumentPayerEFTRequestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a document ERA request
     * Create an ERA
     */
    async createSupportDocumentPayerERARequestRaw(requestParameters: CreateSupportDocumentPayerERARequestRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportDocumentPayerERARequest.');
        }

        if (requestParameters['supportCreateDocumentERAPayload'] === null || requestParameters['supportCreateDocumentERAPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentERAPayload','Required parameter requestParameters.supportCreateDocumentERAPayload was null or undefined when calling createSupportDocumentPayerERARequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/payer/{id}/era`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentERAPayloadToJSON(requestParameters['supportCreateDocumentERAPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Create a document ERA request
     * Create an ERA
     */
    async createSupportDocumentPayerERARequest(requestParameters: CreateSupportDocumentPayerERARequestRequest): Promise<SupportDocument> {
        const response = await this.createSupportDocumentPayerERARequestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a document upload
     * Create a document upload
     */
    async createSupportDocumentUploadRaw(requestParameters: CreateSupportDocumentUploadRequest): Promise<runtime.ApiResponse<DocumentUpload>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportDocumentUpload.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling createSupportDocumentUpload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "update:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/upload`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentUploadFromJSON(jsonValue));
    }

    /**
     * Create a document upload
     * Create a document upload
     */
    async createSupportDocumentUpload(requestParameters: CreateSupportDocumentUploadRequest): Promise<DocumentUpload> {
        const response = await this.createSupportDocumentUploadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportEOBExplanationOfBenefitsDocumentRaw(requestParameters: CreateSupportEOBExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportEOBExplanationOfBenefitsDocument.');
        }

        if (requestParameters['supportCreateDocumentPaymentPayload'] === null || requestParameters['supportCreateDocumentPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentPaymentPayload','Required parameter requestParameters.supportCreateDocumentPaymentPayload was null or undefined when calling createSupportEOBExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/eob/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentPaymentPayloadToJSON(requestParameters['supportCreateDocumentPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportEOBExplanationOfBenefitsDocument(requestParameters: CreateSupportEOBExplanationOfBenefitsDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportEOBExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportEOBPaymentExplanationOfBenefitsDocumentRaw(requestParameters: CreateSupportEOBPaymentExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportEOBPaymentExplanationOfBenefitsDocument.');
        }

        if (requestParameters['supportCreateDocumentPaymentPayload'] === null || requestParameters['supportCreateDocumentPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentPaymentPayload','Required parameter requestParameters.supportCreateDocumentPaymentPayload was null or undefined when calling createSupportEOBPaymentExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/eob/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentPaymentPayloadToJSON(requestParameters['supportCreateDocumentPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportEOBPaymentExplanationOfBenefitsDocument(requestParameters: CreateSupportEOBPaymentExplanationOfBenefitsDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportEOBPaymentExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a NF3 paper claim
     * Create a paper NF3 from an NF3 claim
     */
    async createSupportNynf3DocumentRaw(requestParameters: CreateSupportNynf3DocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportNynf3Document.');
        }

        if (requestParameters['supportCreateDocumentNynf3Payload'] === null || requestParameters['supportCreateDocumentNynf3Payload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentNynf3Payload','Required parameter requestParameters.supportCreateDocumentNynf3Payload was null or undefined when calling createSupportNynf3Document.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/nynf3/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentNynf3PayloadToJSON(requestParameters['supportCreateDocumentNynf3Payload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Create a NF3 paper claim
     * Create a paper NF3 from an NF3 claim
     */
    async createSupportNynf3Document(requestParameters: CreateSupportNynf3DocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportNynf3DocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportPaymentExplanationOfBenefitsDocumentRaw(requestParameters: CreateSupportPaymentExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportPaymentExplanationOfBenefitsDocument.');
        }

        if (requestParameters['supportCreateDocumentPaymentPayload'] === null || requestParameters['supportCreateDocumentPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentPaymentPayload','Required parameter requestParameters.supportCreateDocumentPaymentPayload was null or undefined when calling createSupportPaymentExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentPaymentPayloadToJSON(requestParameters['supportCreateDocumentPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Creates a paper explanation of benefits
     * Creates a paper explanation of benefits
     */
    async createSupportPaymentExplanationOfBenefitsDocument(requestParameters: CreateSupportPaymentExplanationOfBenefitsDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportPaymentExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a paper proof of electronic transmission
     * Creates a paper proof of electronic transmission
     */
    async createSupportProofOfTransmissionDocumentRaw(requestParameters: CreateSupportProofOfTransmissionDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createSupportProofOfTransmissionDocument.');
        }

        if (requestParameters['supportCreateDocumentProofOfTransmissionPayload'] === null || requestParameters['supportCreateDocumentProofOfTransmissionPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentProofOfTransmissionPayload','Required parameter requestParameters.supportCreateDocumentProofOfTransmissionPayload was null or undefined when calling createSupportProofOfTransmissionDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/transmission/{id}/proof`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentProofOfTransmissionPayloadToJSON(requestParameters['supportCreateDocumentProofOfTransmissionPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Creates a paper proof of electronic transmission
     * Creates a paper proof of electronic transmission
     */
    async createSupportProofOfTransmissionDocument(requestParameters: CreateSupportProofOfTransmissionDocumentRequest): Promise<SupportDocument> {
        const response = await this.createSupportProofOfTransmissionDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a document
     * Disable a document
     */
    async disableSupportDocumentRaw(requestParameters: DisableSupportDocumentRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a document
     * Disable a document
     */
    async disableSupportDocument(requestParameters: DisableSupportDocumentRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a document
     * Enable a document
     */
    async enableSupportDocumentRaw(requestParameters: EnableSupportDocumentRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enableSupportDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a document
     * Enable a document
     */
    async enableSupportDocument(requestParameters: EnableSupportDocumentRequest): Promise<ObjectNoResponse> {
        const response = await this.enableSupportDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generates the OCR associated with a document
     * Generates the OCR associated with a document
     */
    async generateDocumentOcrRaw(requestParameters: GenerateDocumentOcrRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling generateDocumentOcr.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/ocr`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Generates the OCR associated with a document
     * Generates the OCR associated with a document
     */
    async generateDocumentOcr(requestParameters: GenerateDocumentOcrRequest): Promise<ObjectNoResponse> {
        const response = await this.generateDocumentOcrRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generates the OCR analyze associated with a document
     * Generates the OCR analyze associated with a document
     */
    async generateDocumentOcrAnalyzeRaw(requestParameters: GenerateDocumentOcrAnalyzeRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling generateDocumentOcrAnalyze.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling generateDocumentOcrAnalyze.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/ocr/analyze`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Generates the OCR analyze associated with a document
     * Generates the OCR analyze associated with a document
     */
    async generateDocumentOcrAnalyze(requestParameters: GenerateDocumentOcrAnalyzeRequest): Promise<ObjectNoResponse> {
        const response = await this.generateDocumentOcrAnalyzeRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document
     * Get a document
     */
    async getProviderDocumentRaw(requestParameters: GetProviderDocumentRequest): Promise<runtime.ApiResponse<ProviderDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderDocumentFromJSON(jsonValue));
    }

    /**
     * Gets a document
     * Get a document
     */
    async getProviderDocument(requestParameters: GetProviderDocumentRequest): Promise<ProviderDocument> {
        const response = await this.getProviderDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get the transcription of the audio document
     * Get the transcription of the audio document
     */
    async getProviderDocumentTranscriptionRaw(requestParameters: GetProviderDocumentTranscriptionRequest): Promise<runtime.ApiResponse<ProviderDocumentTranscription>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderDocumentTranscription.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:document"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/{id}/transcription`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderDocumentTranscriptionFromJSON(jsonValue));
    }

    /**
     * Get the transcription of the audio document
     * Get the transcription of the audio document
     */
    async getProviderDocumentTranscription(requestParameters: GetProviderDocumentTranscriptionRequest): Promise<ProviderDocumentTranscription> {
        const response = await this.getProviderDocumentTranscriptionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getProviderDocumentUrlRaw(requestParameters: GetProviderDocumentUrlRequest): Promise<runtime.ApiResponse<ProviderDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderDocumentUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/{id}/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getProviderDocumentUrl(requestParameters: GetProviderDocumentUrlRequest): Promise<ProviderDocumentUrl> {
        const response = await this.getProviderDocumentUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getProviderEmbedDocumentUrlRaw(requestParameters: GetProviderEmbedDocumentUrlRequest): Promise<runtime.ApiResponse<ProviderDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderEmbedDocumentUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/{id}/embed`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getProviderEmbedDocumentUrl(requestParameters: GetProviderEmbedDocumentUrlRequest): Promise<ProviderDocumentUrl> {
        const response = await this.getProviderEmbedDocumentUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document
     * Get a document
     */
    async getSupportDocumentRaw(requestParameters: GetSupportDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Gets a document
     * Get a document
     */
    async getSupportDocument(requestParameters: GetSupportDocumentRequest): Promise<SupportDocument> {
        const response = await this.getSupportDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get the OCR of the document
     * Get the OCR of the document
     */
    async getSupportDocumentOcrRaw(requestParameters: GetSupportDocumentOcrRequest): Promise<runtime.ApiResponse<SupportDocumentOcr>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportDocumentOcr.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:document", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/ocr`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentOcrFromJSON(jsonValue));
    }

    /**
     * Get the OCR of the document
     * Get the OCR of the document
     */
    async getSupportDocumentOcr(requestParameters: GetSupportDocumentOcrRequest): Promise<SupportDocumentOcr> {
        const response = await this.getSupportDocumentOcrRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get the OCR analyze of a receive fax item
     * Get the OCR analyze of a receive fax item
     */
    async getSupportDocumentOcrAnalyzeRaw(requestParameters: GetSupportDocumentOcrAnalyzeRequest): Promise<runtime.ApiResponse<SupportDocumentOcrAnalyze>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportDocumentOcrAnalyze.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:document", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/ocr/analyze`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentOcrAnalyzeFromJSON(jsonValue));
    }

    /**
     * Get the OCR analyze of a receive fax item
     * Get the OCR analyze of a receive fax item
     */
    async getSupportDocumentOcrAnalyze(requestParameters: GetSupportDocumentOcrAnalyzeRequest): Promise<SupportDocumentOcrAnalyze> {
        const response = await this.getSupportDocumentOcrAnalyzeRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get the transcription of the audio document
     * Get the transcription of the audio document
     */
    async getSupportDocumentTranscriptionRaw(requestParameters: GetSupportDocumentTranscriptionRequest): Promise<runtime.ApiResponse<SupportDocumentTranscription>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportDocumentTranscription.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:document", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/transcription`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentTranscriptionFromJSON(jsonValue));
    }

    /**
     * Get the transcription of the audio document
     * Get the transcription of the audio document
     */
    async getSupportDocumentTranscription(requestParameters: GetSupportDocumentTranscriptionRequest): Promise<SupportDocumentTranscription> {
        const response = await this.getSupportDocumentTranscriptionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getSupportDocumentUrlRaw(requestParameters: GetSupportDocumentUrlRequest): Promise<runtime.ApiResponse<SupportDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportDocumentUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getSupportDocumentUrl(requestParameters: GetSupportDocumentUrlRequest): Promise<SupportDocumentUrl> {
        const response = await this.getSupportDocumentUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get an embeddable url for a page of a document converted to an image.
     * Get an embeddable url for a page of a document
     */
    async getSupportEmbedDocumentPageImageUrlRaw(requestParameters: GetSupportEmbedDocumentPageImageUrlRequest): Promise<runtime.ApiResponse<SupportDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportEmbedDocumentPageImageUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/embed/image`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Get an embeddable url for a page of a document converted to an image.
     * Get an embeddable url for a page of a document
     */
    async getSupportEmbedDocumentPageImageUrl(requestParameters: GetSupportEmbedDocumentPageImageUrlRequest): Promise<SupportDocumentUrl> {
        const response = await this.getSupportEmbedDocumentPageImageUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getSupportEmbedDocumentUrlRaw(requestParameters: GetSupportEmbedDocumentUrlRequest): Promise<runtime.ApiResponse<SupportDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportEmbedDocumentUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/embed`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async getSupportEmbedDocumentUrl(requestParameters: GetSupportEmbedDocumentUrlRequest): Promise<SupportDocumentUrl> {
        const response = await this.getSupportEmbedDocumentUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of documents
     * Get a list of documents
     */
    async listProviderDocumentsRaw(requestParameters: ListProviderDocumentsRequest): Promise<runtime.ApiResponse<Array<ProviderDocument>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterFilename) {
            queryParameters['filterFilename'] = requestParameters.filterFilename;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentType) {
            queryParameters['filterDocumentType'] = requestParameters.filterDocumentType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderDocumentFromJSON));
    }

    /**
     * Gets a list of documents
     * Get a list of documents
     */
    async listProviderDocuments(requestParameters: ListProviderDocumentsRequest): Promise<Array<ProviderDocument>> {
        const response = await this.listProviderDocumentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of documents
     * Get a list of documents
     */
    async listSupportDocumentsRaw(requestParameters: ListSupportDocumentsRequest): Promise<runtime.ApiResponse<Array<SupportDocument>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterFilename) {
            queryParameters['filterFilename'] = requestParameters.filterFilename;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterDocumentType) {
            queryParameters['filterDocumentType'] = requestParameters.filterDocumentType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportDocumentFromJSON));
    }

    /**
     * Gets a list of documents
     * Get a list of documents
     */
    async listSupportDocuments(requestParameters: ListSupportDocumentsRequest): Promise<Array<SupportDocument>> {
        const response = await this.listSupportDocumentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Refreshes document metadata (height, width, filesize, thumbnail, mimetype)
     * Refreshes document metadata (height, width, filesize, thumbnail, mimetype)
     */
    async refreshDocumentMetadataRaw(requestParameters: RefreshDocumentMetadataRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling refreshDocumentMetadata.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling refreshDocumentMetadata.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/refresh_metadata`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Refreshes document metadata (height, width, filesize, thumbnail, mimetype)
     * Refreshes document metadata (height, width, filesize, thumbnail, mimetype)
     */
    async refreshDocumentMetadata(requestParameters: RefreshDocumentMetadataRequest): Promise<ObjectNoResponse> {
        const response = await this.refreshDocumentMetadataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Refreshes document metadata (height, width, filesize, thumbnail, mimetype)
     * Refreshes document metadata (height, width, filesize, thumbnail, mimetype)
     */
    async refreshProviderDocumentMetadataRaw(requestParameters: RefreshProviderDocumentMetadataRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling refreshProviderDocumentMetadata.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling refreshProviderDocumentMetadata.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/{id}/refresh_metadata`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Refreshes document metadata (height, width, filesize, thumbnail, mimetype)
     * Refreshes document metadata (height, width, filesize, thumbnail, mimetype)
     */
    async refreshProviderDocumentMetadata(requestParameters: RefreshProviderDocumentMetadataRequest): Promise<ObjectNoResponse> {
        const response = await this.refreshProviderDocumentMetadataRaw(requestParameters);
        return await response.value();
    }

    /**
     * Resize a document
     * Resizes a document
     */
    async resizeDocumentRaw(requestParameters: ResizeDocumentRequest): Promise<runtime.ApiResponse<SupportDocument>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling resizeDocument.');
        }

        if (requestParameters['supportCreateDocumentResizePayload'] === null || requestParameters['supportCreateDocumentResizePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentResizePayload','Required parameter requestParameters.supportCreateDocumentResizePayload was null or undefined when calling resizeDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}/resize`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentResizePayloadToJSON(requestParameters['supportCreateDocumentResizePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDocumentFromJSON(jsonValue));
    }

    /**
     * Resize a document
     * Resizes a document
     */
    async resizeDocument(requestParameters: ResizeDocumentRequest): Promise<SupportDocument> {
        const response = await this.resizeDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a document
     * Update a document
     */
    async updateSupportDocumentRaw(requestParameters: UpdateSupportDocumentRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportDocument.');
        }

        if (requestParameters['supportUpdateDocumentPayload'] === null || requestParameters['supportUpdateDocumentPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateDocumentPayload','Required parameter requestParameters.supportUpdateDocumentPayload was null or undefined when calling updateSupportDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateDocumentPayloadToJSON(requestParameters['supportUpdateDocumentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a document
     * Update a document
     */
    async updateSupportDocument(requestParameters: UpdateSupportDocumentRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get url for a CMS-450 institutional
     * Get url for a CMS-1450 institutional
     */
    async viewProviderCMS1450DocumentRaw(requestParameters: ViewProviderCMS1450DocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewProviderCMS1450Document.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.editable !== undefined) {
            queryParameters['editable'] = requestParameters.editable;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/institutional/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Get url for a CMS-450 institutional
     * Get url for a CMS-1450 institutional
     */
    async viewProviderCMS1450Document(requestParameters: ViewProviderCMS1450DocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewProviderCMS1450DocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get url for a CMS-1500 professional
     * Get url for a CMS-1500 professional
     */
    async viewProviderCMS1500DocumentRaw(requestParameters: ViewProviderCMS1500DocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewProviderCMS1500Document.');
        }

        if (requestParameters['payerSubscriberId'] === null || requestParameters['payerSubscriberId'] === undefined) {
            throw new runtime.RequiredError('payerSubscriberId','Required parameter requestParameters.payerSubscriberId was null or undefined when calling viewProviderCMS1500Document.');
        }

        if (requestParameters['subscriberPatientId'] === null || requestParameters['subscriberPatientId'] === undefined) {
            throw new runtime.RequiredError('subscriberPatientId','Required parameter requestParameters.subscriberPatientId was null or undefined when calling viewProviderCMS1500Document.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.payerSubscriberId !== undefined) {
            queryParameters['payerSubscriberId'] = requestParameters.payerSubscriberId;
        }

        if (requestParameters.subscriberPatientId !== undefined) {
            queryParameters['subscriberPatientId'] = requestParameters.subscriberPatientId;
        }

        if (requestParameters.editable !== undefined) {
            queryParameters['editable'] = requestParameters.editable;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/professional/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Get url for a CMS-1500 professional
     * Get url for a CMS-1500 professional
     */
    async viewProviderCMS1500Document(requestParameters: ViewProviderCMS1500DocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewProviderCMS1500DocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewProviderClaimTransmissionDocumentRaw(requestParameters: ViewProviderClaimTransmissionDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewProviderClaimTransmissionDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/transmission/{id}/claim/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewProviderClaimTransmissionDocument(requestParameters: ViewProviderClaimTransmissionDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewProviderClaimTransmissionDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get document url for a paper payment
     * Get document url for a paper payment
     */
    async viewProviderPaymentExplanationOfBenefitsDocumentRaw(requestParameters: ViewProviderPaymentExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewProviderPaymentExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/document/payment/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Get document url for a paper payment
     * Get document url for a paper payment
     */
    async viewProviderPaymentExplanationOfBenefitsDocument(requestParameters: ViewProviderPaymentExplanationOfBenefitsDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewProviderPaymentExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportCMS1450DocumentRaw(requestParameters: ViewSupportCMS1450DocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportCMS1450Document.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.editable !== undefined) {
            queryParameters['editable'] = requestParameters.editable;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/institutional/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportCMS1450Document(requestParameters: ViewSupportCMS1450DocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportCMS1450DocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a generated CMS-1500 document url
     * Gets a generated CMS-1500 document url
     */
    async viewSupportCMS1500DocumentRaw(requestParameters: ViewSupportCMS1500DocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportCMS1500Document.');
        }

        if (requestParameters['payerSubscriberId'] === null || requestParameters['payerSubscriberId'] === undefined) {
            throw new runtime.RequiredError('payerSubscriberId','Required parameter requestParameters.payerSubscriberId was null or undefined when calling viewSupportCMS1500Document.');
        }

        if (requestParameters['subscriberPatientId'] === null || requestParameters['subscriberPatientId'] === undefined) {
            throw new runtime.RequiredError('subscriberPatientId','Required parameter requestParameters.subscriberPatientId was null or undefined when calling viewSupportCMS1500Document.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.payerSubscriberId !== undefined) {
            queryParameters['payerSubscriberId'] = requestParameters.payerSubscriberId;
        }

        if (requestParameters.subscriberPatientId !== undefined) {
            queryParameters['subscriberPatientId'] = requestParameters.subscriberPatientId;
        }

        if (requestParameters.editable !== undefined) {
            queryParameters['editable'] = requestParameters.editable;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/professional/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a generated CMS-1500 document url
     * Gets a generated CMS-1500 document url
     */
    async viewSupportCMS1500Document(requestParameters: ViewSupportCMS1500DocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportCMS1500DocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportClaimTransmissionDocumentRaw(requestParameters: ViewSupportClaimTransmissionDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportClaimTransmissionDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/transmission/{id}/claim/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportClaimTransmissionDocument(requestParameters: ViewSupportClaimTransmissionDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportClaimTransmissionDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportClearinghouseEraExplanationOfBenefitsDocumentRaw(requestParameters: ViewSupportClearinghouseEraExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportClearinghouseEraExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/clearinghouse/era/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportClearinghouseEraExplanationOfBenefitsDocument(requestParameters: ViewSupportClearinghouseEraExplanationOfBenefitsDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportClearinghouseEraExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportClearinghouseEraItemExplanationOfBenefitsDocumentRaw(requestParameters: ViewSupportClearinghouseEraItemExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportClearinghouseEraItemExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/clearinghouse/era/item/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportClearinghouseEraItemExplanationOfBenefitsDocument(requestParameters: ViewSupportClearinghouseEraItemExplanationOfBenefitsDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportClearinghouseEraItemExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportEOBExplanationOfBenefitsDocumentRaw(requestParameters: ViewSupportEOBExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportEOBExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/eob/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportEOBExplanationOfBenefitsDocument(requestParameters: ViewSupportEOBExplanationOfBenefitsDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportEOBExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportEOBPaymentExplanationOfBenefitsDocumentRaw(requestParameters: ViewSupportEOBPaymentExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportEOBPaymentExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/eob/payment/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportEOBPaymentExplanationOfBenefitsDocument(requestParameters: ViewSupportEOBPaymentExplanationOfBenefitsDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportEOBPaymentExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportNynf3DocumentRaw(requestParameters: ViewSupportNynf3DocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportNynf3Document.');
        }

        if (requestParameters['payerSubscriberId'] === null || requestParameters['payerSubscriberId'] === undefined) {
            throw new runtime.RequiredError('payerSubscriberId','Required parameter requestParameters.payerSubscriberId was null or undefined when calling viewSupportNynf3Document.');
        }

        if (requestParameters['subscriberPatientId'] === null || requestParameters['subscriberPatientId'] === undefined) {
            throw new runtime.RequiredError('subscriberPatientId','Required parameter requestParameters.subscriberPatientId was null or undefined when calling viewSupportNynf3Document.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.payerSubscriberId !== undefined) {
            queryParameters['payerSubscriberId'] = requestParameters.payerSubscriberId;
        }

        if (requestParameters.subscriberPatientId !== undefined) {
            queryParameters['subscriberPatientId'] = requestParameters.subscriberPatientId;
        }

        if (requestParameters.editable !== undefined) {
            queryParameters['editable'] = requestParameters.editable;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/nynf3/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportNynf3Document(requestParameters: ViewSupportNynf3DocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportNynf3DocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportPaymentExplanationOfBenefitsDocumentRaw(requestParameters: ViewSupportPaymentExplanationOfBenefitsDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportPaymentExplanationOfBenefitsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/payment/{id}/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportPaymentExplanationOfBenefitsDocument(requestParameters: ViewSupportPaymentExplanationOfBenefitsDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportPaymentExplanationOfBenefitsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportProofOfTransmissionDocumentRaw(requestParameters: ViewSupportProofOfTransmissionDocumentRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling viewSupportProofOfTransmissionDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/transmission/{id}/proof/view`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Gets a document\'s url
     * Get a document\'s url
     */
    async viewSupportProofOfTransmissionDocument(requestParameters: ViewSupportProofOfTransmissionDocumentRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.viewSupportProofOfTransmissionDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Zip documents
     * Zip documents together
     */
    async zipDocumentsRaw(requestParameters: ZipDocumentsRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['supportCreateDocumentZipPayload'] === null || requestParameters['supportCreateDocumentZipPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateDocumentZipPayload','Required parameter requestParameters.supportCreateDocumentZipPayload was null or undefined when calling zipDocuments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:documents", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/document/zip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateDocumentZipPayloadToJSON(requestParameters['supportCreateDocumentZipPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Zip documents
     * Zip documents together
     */
    async zipDocuments(requestParameters: ZipDocumentsRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.zipDocumentsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderDocumentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportDocumentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
